export const FORM_ID = "setup-dashboard-variable-form";
